{
	"title": "Servicio no disponible (500)",
	"description": "Intente actualizar esta página o verifique su conexión a Internet. Si este error persiste, infórmelo como un error para que podamos tomar medidas.",
	"primaryButtonTitle": "Actualizar página",
	"secondaryButtonTitle": "Copiar registro de errores",
	"errorLogCopiedMessage": "Registro de errores copiado",
	"traceparentLabel": "Traceparent"
}
